import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Stara ruta — preusmjeri na novi kombinirani flow
function PasswordChangeConfirm() {
    const navigate = useNavigate();
    useEffect(() => { navigate("/passwordChangeRequest", { replace: true }); }, [navigate]);
    return null;
}

export default PasswordChangeConfirm;
